import apiClient from "services/apiClient";

async function updateBrand(id: number, body: any): Promise<any> {
    const res = await apiClient.put(`/admin/brands/${id}`, body);
    return res.data;
}

export default updateBrand;